import React from "react";

export const OrdersPlaceholder = () => {
  return (
    <div className="orders-wrapper">
      <div className="orders-header">
        <div className="orders-header-title">Orders</div>
      </div>
      <div className="orders-table-headers-wrapper">
        <div className="orders-table-headers">
          <span className="orders-table-headers-item order-id">Order ID</span>
          <span className="orders-table-headers-item order-type">
            Order Type
          </span>
          <span className="orders-table-headers-item stream-rate-min">Min</span>
          <span className="orders-table-headers-item stream-rate">
            Aggregate Stream Rate
          </span>
          <span className="orders-table-headers-item stream-rate-max">Max</span>
          <span className="orders-table-headers-item average-price">
            Avg Price
          </span>
          <span className="orders-table-headers-item limit">Limit</span>
          <span className="orders-table-headers-item quantity">Quantity</span>
        </div>
      </div>
    </div>
  );
};
